import { ReactNode } from 'react'
import BaseModal, { ModalProps as BaseModalProps } from 'antd/lib/modal'

export interface ModalProps
  extends Omit<
    BaseModalProps,
    'closable' | 'centered' | 'mask' | 'maskClosable'
  > {
  children?: ReactNode
}

export const Modal = ({ title, ...rest }: ModalProps): JSX.Element => (
  <>
    <BaseModal
      closable
      centered
      mask
      maskClosable={false}
      title={<span className="text-5xl font-medium">{title}</span>}
      {...rest}
    />
  </>
)

export default Modal
